import React, { useState, useEffect } from 'react';
// import { PDFDownloadLink } from '@react-pdf/renderer';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { PdfHtml } from './html-pdf';
import '../pdf/styles.css';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

export default function Pdf(props) {
    const [newDados, setDados] = useState([]);
    const [title, setTitle] = useState([]);
    const [show, setHide] = useState(false);
    const [loading, setLoading] = useState('loading');
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);

    //Gerar para impressão
    useEffect(() => {
        const fetchPdf = () => {
            const dados = [
                {
                    nome: 'Contratante',
                    valor: props.dados.nome
                },

                {
                    nome: 'Adesão',
                    valor: props.dados.valor
                },

                {
                    nome: 'Inscrição',
                    valor: props.dados.numero_contrato
                },

                {
                    nome: 'Data Venda',
                    valor: props.dados.data
                },

                {
                    nome: 'Vendedor',
                    valor: ` ${decriptoLocalStorage('Nome')?.decriptoValue}`
                },
                {
                    nome: 'cidade',
                    valor: props.dados.cidade
                }
            ];

            setDados(dados);
            setHide(true);
        };

        fetchPdf();
    }, []);

    return (
        <div style={{ height: '200px' }}>
            <div className={loading}>
                <ProgressSpinner
                    style={{ width: '100px',
                        height: '100px' }}
                    strokeWidth="1"
                    fill="#EEEEEE"
                    animationDuration=".5s"
                />
            </div>

            {show && (
                <div  className='downloadComprovante' >
                    {/* <PDFDownloadLink
                        document={<PdfHtml dados={newDados} />}
                        fileName="Comprovante de pagamento.pdf"
                        className='downloadComprovanteContent'
                    >
                        {({ blob, url, loading, error }) =>
                            loading ?
                                'Loading document...' :
                                'Recibo gerado, click para Baixar'
                        }
                    </PDFDownloadLink> */}
                </div>
            )}
            <div>
                <br />
                <br />
                <div className="quinhentos p-col-6 p-md-6">
                    {sucesso && (
                        <Message severity="success" text="Contrato enviado" />
                    )}
                    {erro ? (
                        <Message
                            severity="error"
                            text="Ops, não conseguimos salvar"
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    );
}
